
export const NOF_CONFIGURE_THRESHOLD_PERMISSION: string[] = [ 'NOF_SEUILS_ALERTE', 'NOF_ADMIN'];
export const NOF_TEAMS_CAMPAIGN_PERMISSION: string[] = [ 'NOF_CAMPAGNES_TEAMS', 'NOF_ADMIN'];
